let reduxStore: any = null;

export const setStore = (store: any) => {
  reduxStore = store;
};

export const getStore = () => reduxStore;
